export default __webpack_public_path__ + "static/media/pic5.180c0b37.jpg";